import React from 'react';
import cn from 'classnames';

import IMG_ARROW_TOGGLE from 'assets/images/time-off-panel/arrow-toggle.svg';
import determineDisplayNumberOf from 'bl/timeoff/determineDisplayNumberOf.bl';
import SvgIcon from 'components/generic/SvgIcon.component';
import { withTheme } from 'providers/Theme.provider';
import asArray from 'utils/arrays/asArray.util';
import asObject from 'utils/objects/asObject.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './StylistAllowancesTable.module.scss';

const EMPTY = '--';

const StylistAllowancesTable = ({ value, headers, isDarkMode, isHoursSelected }) => (
  <div className={cn({ [CN.component]: true, [CN.dark]: isDarkMode })}>
    <table data-bem="StylistToggleButton__table" className={CN.table}>
      <thead>
        <tr>
          {asArray(headers).map((header, index) => (
            <th key={createNodeKey({ unique: header, index })}>
              <div className={CN.headerColumn}>
                <span className={CN.columnTitle}>{header}</span>
                <div className={CN.arrow}>
                  <SvgIcon alt="arrow toggle" icon={IMG_ARROW_TOGGLE} size="small" />
                </div>
              </div>
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {Object.values(asObject(value)).map(
          ({
            categoryId,
            categoryName,
            allowanceDays,
            allowanceHours,
            usedDays,
            excessDays,
            excessHours,
            remainingDays,
            remainingHours,
            upcomingDays,
            upcomingHours,
            usedHours,
          }) => {
            const displayUsed = determineDisplayNumberOf({
              isHoursSelected,
              hours: usedHours,
              days: usedDays,
              defaultValue: EMPTY,
            });
            const displayUpcoming = determineDisplayNumberOf({
              isHoursSelected,
              hours: upcomingHours,
              days: upcomingDays,
              defaultValue: EMPTY,
            });
            const displayAllowance = determineDisplayNumberOf({
              isHoursSelected,
              hours: allowanceHours,
              days: allowanceDays,
              defaultValue: EMPTY,
            });
            const displayRemaining = determineDisplayNumberOf({
              isHoursSelected,
              hours: remainingHours,
              days: remainingDays,
              defaultValue: EMPTY,
            });
            const displayExcess = determineDisplayNumberOf({
              isHoursSelected,
              hours: excessHours,
              days: excessDays,
              defaultValue: EMPTY,
            });

            return (
              <tr key={categoryId}>
                <td>{categoryName}</td>
                <td>
                  <span className={CN.emphasis}>{displayAllowance}</span>
                </td>
                <td>
                  <span className={CN.emphasis}>{displayUsed}</span>
                </td>
                <td>
                  <span className={CN.emphasis}>{displayUpcoming}</span>
                </td>
                <td>
                  <span className={CN.emphasis}>{displayRemaining}</span>
                </td>
                <td>
                  <span className={CN.warning}>{displayExcess}</span>
                </td>
              </tr>
            );
          },
        )}
      </tbody>
    </table>
  </div>
);

const StylistAllowancesTableHoc = withTheme()(StylistAllowancesTable);

export default StylistAllowancesTableHoc;
